import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter',
  standalone: true,
})
export class SearchFilterPipe implements PipeTransform {
  transform(items: any[], val: any) {
    const valStr = typeof val === 'string' ? val.toLowerCase() : val;

    return items.filter((item: any) => {
      const strValue =
        typeof item.value === 'string' ? item.value.toLowerCase() : item.value;
      const strName = item.name.toLowerCase();

      return !!(strName.includes(valStr) || strValue.includes(valStr));
    });
  }
}
